(function () {
  const tickSlider = () => {
		$(".ticker").each(function(){
			if ($(this).hasClass('slider_started')){
				return ''
			}
			$(this).addClass('slider_started');
			const tickerId = $(this).data('ticker-id');
			const tickerSpeed = $(this).data('ticker-speed') * 1000;
			const isMobile = window.matchMedia('(max-width: 749px)').matches;
			const tickerSwiper = new Swiper(`.ticker-js-${tickerId}`, {
				slidesPerView: "auto",
				speed: tickerSpeed,
				initialSlide: 0,
				loop: false,
				loopedSlides: 50,
				allowTouchMove: false,
				waitForTransition: false,
				watchSlidesProgress: false,
				autoplay: isMobile ? false : {
					delay: 0,
					disableOnInteraction: true,
				},
			});

			const controlBtn = $(this).find('.ticker-control');
			if (controlBtn.length) {
				controlBtn.on('click', function () {
					const isPlaying = $(this).hasClass('ticker-control--playing');
					if (isPlaying) {
						tickerSwiper.autoplay.stop();
						tickerSwiper.setTranslate(tickerSwiper.getTranslate());
						$(this).removeClass('ticker-control--playing').addClass('ticker-control--paused');
						$(this).attr('aria-pressed', 'true');
						$(this).find('.ticker-control__label').text('Start Movement');
					} else {
						tickerSwiper.autoplay.start();
						$(this).removeClass('ticker-control--paused').addClass('ticker-control--playing');
						$(this).attr('aria-pressed', 'false');
						$(this).find('.ticker-control__label').text('Stop Movement');
					}
				});
			}
		})
  };

  tickSlider();
  document.addEventListener("shopify:section:load", function () {
    setTimeout(() => {
      tickSlider();
    }, 100);
  });

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) {
      $(".ticker-js").each(function () {
        this.swiper.destroy();
      });
      tickSlider();
    }
  });

  setTimeout(() => {
    tickSlider();
  }, 100);
})();
